import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { BRAND, purchaseNotice } from '../data/sushiContent';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, []);
  return <AnimatePresence data-id="element-240" data-mp="2qvhwbiy3thjx">
      {visible && <motion.aside initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-label="Compra reciente" className="fixed bottom-24 left-4 z-30 hidden max-w-[19rem] items-start gap-3 border border-charcoal-600 bg-charcoal-900/95 px-4 py-3 shadow-card backdrop-blur lg:bottom-6 lg:flex" data-id="element-241" data-mp="2lvv8ygokakxe">
          <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" strokeWidth={2} aria-hidden="true" data-id="element-242" data-mp="b3ah25pj2ymk" />
          <div className="min-w-0" data-id="element-243" data-mp="1z52qct8mlrri">
            <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-champagne" data-id="element-244" data-mp="1z412tpafbcsw">
              Compra verificada
            </p>
            <p className="mt-1 text-[13px] leading-snug text-ivory-100" data-id="element-245" data-mp="286agup4whob1">
              <span className="font-medium" data-id="element-246" data-mp="2846b01nfyf84">{purchaseNotice.name}</span> de{' '}
              {purchaseNotice.location} compró {BRAND}
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-muted" data-id="element-247" data-mp="1fgtqdx0uchhg">
              hace {purchaseNotice.minutesAgo} minutos
            </p>
          </div>
          <button type="button" onClick={() => setVisible(false)} className="-mr-1 -mt-1 shrink-0 p-1 text-muted transition-colors duration-150 ease-out hover:text-ivory-100" data-id="element-248" data-mp="1p7elhahb33vm">
            <XIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-249" data-mp="wqbytvrqvrxo" />
            <span className="sr-only" data-id="element-250" data-mp="201rgvlhujqfl">Descartar notificación</span>
          </button>
        </motion.aside>}
    </AnimatePresence>;
}